import React from 'react';
import { useState, useRef, useContext, useCallback } from 'react';
import { useEffect } from 'react';
import lock from '../../assets/img/lock.svg';
import carbrand from '../../assets/img/carshonda.jpg';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import speedometer from '../../assets/img/speedometer.svg';
import miles from '../../assets/img/miles.jpg'
import gasolinePump from '../../assets/img/gasoline-pump.svg';
import car from '../../assets/img/car.svg';
import book from '../../assets/img/book.svg';
import tag from '../../assets/img/tag.svg';
import Path from '../../assets/img/Path.svg';
import transmission from '../../assets/img/manual-transmission.svg';
import drivetrain from '../../assets/img/drivetrain.svg';
import cars01 from '../../assets/img/cars01.png';
import carshonda from '../../assets/img/carshonda.jpg';
import persent from '../../assets/img/persent.svg';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import Popup from "../../Component/Popup/Popup";
import UrCarCounterBid from "../../Container/UrCardetails/UrCarCounterBid";
import UrCarBidList from "../../Container/UrCardetails/UrBidlist";
import UrCarProxyList from "../../Container/UrCardetails/UrCarProxyBid";
import Accept from "../../Container/UrCardetails/Accept";
import Delete from "../../Container/UrCardetails/Delete";
import ProxyAccept from './ProxyAccept';
import UrCarAction from '../UrCar/UrCarAction';
import Countdown from "react-countdown";
import carcheck from '../../assets/img/carcheck.png';
import barcode from '../../assets/img/barcode.svg';
import Barcode from "react-barcode";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import "../../Component/CommonPopup/commonPopup.css"
import ls from 'local-storage';
import PageNotFound from '../FallBackUI/PageNotFound';
import SealedBid from '../UrCardetails/SealedBid';
import SealedCounterBid from './SealedCounterBid';
import CounterBidTimer from '../Carlist/CounterBidTimer'
import 'bootstrap/dist/css/bootstrap.min.css';
import { OverlayTrigger, Popover, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import WebSocketCaller from '../WebSocket/WebSocket';
import { CountContext } from '../Context/Allcontext';

const CarDetails = (props) => {
	const { send } = WebSocketCaller();
	const { carDetailsData, proxyBidData, sellerPrivilegesData, feeDetailsData } = useContext(CountContext);
	const successData = useSelector(state => state.LoginReducer.payload);
	const history = useHistory();
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const [carDetail, setCarDetail] = useState([]);
	const [proxyBidList, setProxyBidList] = useState([]);
	const [lrgImg, setLrgImg] = useState("");
	const [proxyBid, setProxyBid] = useState("");
	const [proxyBidDisplay, setProxyBidDisplay] = useState("");
	const [lrgVideo, setLrgVideo] = useState("");
	const [isVideoFlag, setIsVideoFlag] = useState(false);
	const [distance, setDistance] = useState("");
	const [copied, setCopied] = useState(false);
	const [copySuccess, setCopySuccess] = useState('');
	const [buyerDealerId, setBuyerDealerId] = useState(null);
	const [sellerDealersId, setSellerDealersId] = useState(null);
	const [highBid, setHighBid] = useState(null);
	const [sellitNow, setSellitNow] = useState(null);
	const [carId, setCarId] = useState(null);
	const [buyerId, setBuyerId] = useState(null);
	const [time, setTime] = useState(null);
	const [countBid, setCountBid] = useState(null);
	const [newBid, setNewBid] = useState(null);
	const [buyDealerId, setBuyDealerId] = useState(null);
	const sellerData = useSelector(state => state.LoginReducer.payload);
	const [isOpenCounter, setIsOpenCounter] = useState(false);
	const [counterBitUpdated, setCounterBitUpdated] = useState(false);
	const [isShown, setIsShown] = useState(false);
	const { state } = useLocation();
	const dealerData = useSelector(state => state.DealerReducer.payload);
	const [isOpenCarHistory, setIsOpenCarHistory] = useState(false);
	const [proxyBuyer, setProxyBuyer] = useState("");
	const [proxyDealer, setProxyDealer] = useState("");
	const [proxyTransport, setProxyTransport] = useState("");
	const [privilegeDetails, setPrivilegeDetails] = useState("");
	const [transportationCharge, setTransportationCharge] = useState("");
	const [isOpenBidList, setisOpenBidList] = useState(false);
	const [isOpenProxyList, setisOpenProxyList] = useState(false);
	const [isOpenProxyAccept, setIsOpenProxyAccept] = useState(false);

	// Popup magnifier states
	const [isPopupOpen, setIsPopupOpen] = useState(false);
	const [popupImages, setPopupImages] = useState([]);
	const [currentImageIndex, setCurrentImageIndex] = useState(0);

	const togglePopupProxyAccept = () => {
		setIsOpenProxyAccept(!isOpenProxyAccept);
	}

	// ── Banner magnifier (WORKING VERSION FROM SECOND IMAGE) ──────────────────────────────────────────────
	const [cardMagnifier, setCardMagnifier] = useState({
		show: false,
		x: 0,
		y: 0,
		imgX: 0,
		imgY: 0,
		activeId: null
	});

	const handleMouseMove = (e, id) => {
		const rect = e.currentTarget.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const y = e.clientY - rect.top;

		setCardMagnifier({
			show: true,
			x,
			y,
			imgX: (x / rect.width) * 100,
			imgY: (y / rect.height) * 100,
			activeId: id
		});
	};

	const handleMouseLeave = () => {
		setCardMagnifier(prev => ({ ...prev, show: false, activeId: null }));
	};

	// ── Popup Magnifier Component ───────────────────────────────────────────
	const PopupMagnifier = ({ images, currentIndex, onClose, onNext, onPrev }) => {
		const [magnifierPos, setMagnifierPos] = useState({ show: false, x: 0, y: 0, imgX: 0, imgY: 0 });
		const [imgError, setImgError] = useState(false);
		const containerRef = useRef(null);
		const imgRef = useRef(null);
		const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

		const currentImage = images[currentIndex];

		const handleMouseMove = (e) => {
			if (!containerRef.current || !imgRef.current) return;

			const imgRect = imgRef.current.getBoundingClientRect();
			const containerRect = containerRef.current.getBoundingClientRect();

			if (
				e.clientX < imgRect.left || e.clientX > imgRect.right ||
				e.clientY < imgRect.top || e.clientY > imgRect.bottom
			) {
				setMagnifierPos(prev => ({ ...prev, show: false }));
				return;
			}
			const x = e.clientX - containerRect.left;
			const y = e.clientY - containerRect.top;

			const imgX = ((e.clientX - imgRect.left) / imgRect.width) * 100;
			const imgY = ((e.clientY - imgRect.top) / imgRect.height) * 100;

			setMagnifierPos({ show: true, x, y, imgX, imgY });
		};

		const handleMouseLeave = () => {
			setMagnifierPos(prev => ({ ...prev, show: false }));
		};

		const handleImageError = () => {
			setImgError(true);
		};

		const handleImageLoad = (e) => {
			if (e.target) {
				setImageDimensions({
					width: e.target.naturalWidth,
					height: e.target.naturalHeight
				});
			}
		};

		useEffect(() => {
			const handleKeyDown = (e) => {
				if (e.key === 'ArrowLeft') {
					onPrev();
				} else if (e.key === 'ArrowRight') {
					onNext();
				} else if (e.key === 'Escape') {
					onClose();
				}
			};

			window.addEventListener('keydown', handleKeyDown);
			return () => window.removeEventListener('keydown', handleKeyDown);
		}, [onPrev, onNext, onClose]);

		useEffect(() => {
			setImgError(false);
			setMagnifierPos({ show: false, x: 0, y: 0, imgX: 0, imgY: 0 });
		}, [currentIndex]);

		if (!currentImage) return null;

		const magnifierSize = window.innerWidth <= 768 ? 150 : 200;
		const zoomScale = 3;
		const bgSize = `${imageDimensions.width * zoomScale}px ${imageDimensions.height * zoomScale}px`;

		return (
			<div className="image-popup-overlay" onClick={onClose}>
				<div className="image-popup-content" onClick={(e) => e.stopPropagation()}>
					<button className="popup-close-btn" onClick={onClose}>×</button>

					{currentIndex > 0 && (
						<button className="popup-nav-btn popup-prev-btn" onClick={(e) => {
							e.stopPropagation();
							onPrev();
						}}>
							&#10094;
						</button>
					)}

					{currentIndex < images.length - 1 && (
						<button className="popup-nav-btn popup-next-btn" onClick={(e) => {
							e.stopPropagation();
							onNext();
						}}>
							&#10095;
						</button>
					)}

					<div className="popup-image-counter">
						{currentIndex + 1} / {images.length}
					</div>

					<div
						ref={containerRef}
						className="popup-image-container"
						onMouseMove={currentImage.format === "image" ? handleMouseMove : undefined}
						onMouseLeave={currentImage.format === "image" ? handleMouseLeave : undefined}
					>
						{imgError ? (
							<div className="popup-image-error">
								<p>Image failed to load</p>
								<button onClick={onClose}>Close</button>
							</div>
						) : (
							<>
								{currentImage.format === "image" || !currentImage.format ? (
									<img
										ref={imgRef}
										src={currentImage.image || currentImage}
										alt="Popup"
										className="popup-image"
										onError={handleImageError}
										onLoad={handleImageLoad}
										draggable={false}
									/>
								) : (
									<video controls className="popup-video" autoPlay={false}>
										<source src={currentImage.image} type="video/mp4" />
									</video>
								)}
							</>
						)}

						{!imgError && (currentImage.format === "image" || !currentImage.format) && (
							<div
								className="popup-magnifier"
								style={{
									display: magnifierPos.show ? 'block' : 'none',
									left: `${magnifierPos.x}px`,
									top: `${magnifierPos.y}px`,
									width: `${magnifierSize}px`,
									height: `${magnifierSize}px`,
									backgroundImage: `url(${currentImage.image || currentImage})`,
									backgroundPosition: `${magnifierPos.imgX}% ${magnifierPos.imgY}%`,
									backgroundSize: imgRef.current
										? `${imgRef.current.getBoundingClientRect().width * zoomScale}px ${imgRef.current.getBoundingClientRect().height * zoomScale}px`
										: `${zoomScale * 100}% ${zoomScale * 100}%`,
									backgroundRepeat: 'no-repeat',
								}}
							/>
						)}
					</div>
				</div>
			</div>
		);
	};

	const isValidMediaUrl = (url) => {
		if (!url) return false;

		const invalidPatterns = [
			'ur2ndlot-dev.s3.amazonaws.com/Inspector/videos/1686765961518_',
			'ur2ndlot-dev.s3.amazonaws.com/buyer/1686726730997_download.png',
			'placeholder',
			'default-image',
			'no-image',
			'coming-soon'
		];
		const hasInvalidPattern = invalidPatterns.some(pattern =>
			url.toLowerCase().includes(pattern.toLowerCase())
		);

		return !hasInvalidPattern && url.trim() !== '';
	};

	const handleImageClick = (clickedImageUrl, clickedIndex) => {
		const allImages = [];
		if (carDetail[0]?.image && isValidMediaUrl(carDetail[0].image)) {
			allImages.push({
				image: carDetail[0].image,
				format: "image",
				id: "main"
			});
		}
		carDetail.slice(1).forEach(item => {
			if ((item.format === "image" || item.image) &&
				isValidMediaUrl(item.image)) {
				allImages.push({
					image: item.image,
					format: item.format || "image",
					id: item.car_images_id
				});
			}
		});

		if (allImages.length === 0) {
			console.log("No valid images available");
			return;
		}

		let validIndex = 0;
		if (clickedIndex !== undefined) {
			if (clickedIndex === 0 && isValidMediaUrl(lrgImg)) {
				validIndex = 0;
			} else {
				let validCount = 0;
				let found = false;
				for (let i = 1; i < carDetail.length; i++) {
					const item = carDetail[i];
					if ((item.format === "image" || item.image) &&
						isValidMediaUrl(item.image)) {
						if (i === clickedIndex) {
							found = true;
							break;
						}
						validCount++;
					}
				}
				validIndex = validCount;
			}
		}

		setPopupImages(allImages);
		setCurrentImageIndex(validIndex);
		setIsPopupOpen(true);
	};

	const handleNextImage = () => {
		if (currentImageIndex < popupImages.length - 1) {
			setCurrentImageIndex(currentImageIndex + 1);
		}
	};

	const handlePrevImage = () => {
		if (currentImageIndex > 0) {
			setCurrentImageIndex(currentImageIndex - 1);
		}
	};
	const sliderRef = useRef(null);
	const scrollUp = () => {
		sliderRef.current.scrollBy({ top: -110, behavior: "smooth" });
	};
	const scrollDown = () => {
		sliderRef.current.scrollBy({ top: 110, behavior: "smooth" });
	};

	// ── Route params ──────────────────────────────────────────────────
	let id = ""
	let sellerDealerId = ""
	let backURL = ""

	let car_Id = ls.get("mailViaCarId")
	let seller_Dealer_Id = ls.get("mailViasellerDealerId")
	const sellerStandingStatus = ls.get("sellerStandingStatus");

	if (car_Id === "" || car_Id === null || car_Id === "null" || car_Id === undefined || car_Id === "undefined") {
		id = props.location.state.id || "";
		sellerDealerId = props.location.state.sellerDealerId;
		backURL = props.location.state.backURL;
	} else {
		id = car_Id;
		sellerDealerId = seller_Dealer_Id;
		backURL = "/carlist"
	}

	const [isOpenPrivileges, setIsOpenPrivileges] = useState(false);
	const [popupTitle, setPopupTitle] = useState("");
	const [popupMsg, setPopupMsg] = useState("");
	const [popupType, setPopupType] = useState("");
	const [popupActionType, setPopupActionType] = useState("");
	const [popupActionValue, setPopupActionValue] = useState("");
	const [popupActionPath, setPopupActionPath] = useState("");
	const [errors, setErrors] = useState("");
	const [errorFlag, setErrorFlag] = useState(false);
	const [data, setData] = useState("");
	const [deleteCar, setDeleteCar] = useState(false);

	const backUrl = ls.get("backredirection");
	const back = backUrl[(backUrl.length) - 1];

	const handleData = (data) => { setData(data) };

	const [isOpenSealedCounterBid, setIsOpenSealedCounterBid] = useState(false);

	const togglePopup = () => { setIsOpenPrivileges(!isOpenPrivileges); }
	const toggleApprove = () => { toggleApproveDelete() }
	const toggleApproveDelete = () => { setDeleteCar(!deleteCar) }

	useEffect(() => {
		privileges(dealerData);
		logedBuyerFees()
	}, [dealerData]);

	const Completionist = () => <span>{""}</span>;

	const renderer = ({ minutes, seconds, completed }) => {
		if (completed) {
			setCounterBitUpdated(false);
			return <Completionist />;
		} else {
			return <span>{minutes}:{seconds}</span>;
		}
	};

	const togglePopupCarHistory = () => { setIsOpenCarHistory(!isOpenCarHistory); }

	const togglePopupSealedCounterBid = (item) => {
		setIsOpenSealedCounterBid(!isOpenSealedCounterBid);
		setSellitNow(item?.max_price);
	}

	const togglePopupCounter = () => { setIsOpenCounter(!isOpenCounter); }
	const togglePopupBidList = () => { setisOpenBidList(!isOpenBidList); }
	const togglePopupProxyList = () => { setisOpenProxyList(!isOpenProxyList); }

	const counterBitUpdateHandler = (value) => { setCounterBitUpdated(value) }

	const [isOpenAccept, setIsOpensAccept] = useState(false);
	const togglePopupAccept = () => { setIsOpensAccept(!isOpenAccept); }

	function CarDetailList(data) {
		const request = {
			car_id: id,
			seller_dealer_id: sellerDealerId,
			seller_id: sellerData.seller_id,
			seller_token: sellerData.seller_token,
		}
		API.post('carDetails/condition', request).then(res => {
			if (res.data.success === true) {
				let merged = []
				for (let i = 0; i < res.data.data.length; i++) {
					merged.push({
						...res.data.data[i], ...(res.data.data1.find((item) => item.car_id === res.data.data[i].car_id))
					})
				}
				merged.sort((a, b) => a.car_image_type_id - b.car_image_type_id);
				setCarDetail(merged)
				setDistance(res.data.distance);
				setLrgImg(res.data.data[0]?.image);
				setLrgVideo(res.data.data[0]?.image);
				setLoading(false);
				setCarId(res.data.data[0]?.car_id)
				setBuyerDealerId(res.data.data[0]?.buyer_dealer_id)
				setSellerDealersId(res.data.data[0]?.seller_dealer_id)
				setHighBid(res.data.data[0]?.high_bid)
				setSellitNow(res.data.data[0]?.max_price)
				setBuyDealerId(res.data.data[0]?.high_buyer_dealer_id)
				setBuyerId(res.data.data[0]?.high_buyer_id)
				setTime(res.data.data[0]?.time)
				setCountBid(res.data.data[0]?.car_max_price)
				setNewBid(res.data.data[0]?.counter_bid)
				setTransportationCharge(res.data.data[0]?.transportation_charge)
				setIsVideoFlag(false)
			} else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}
		}).catch(function (error) {
			if (error.response) {
				setErrors(error.response.data.error)
				setErrorFlag(true)
				setLoading(false);
			}
		});
	}

	function ProxyBid() {
		const request = {
			car_id: id,
			seller_id: sellerData.seller_id,
			seller_token: sellerData.seller_token,
		}
		API.post('proxybidDetails/condition', request).then(res => {
			if (res.data.success === true) {
				setProxyBidList(res.data.data);
				setProxyBid(res.data.data[0]?.proxy_bid)
				setProxyBidDisplay(res.data.data[0]?.display)
				setProxyBuyer(res.data.data[0]?.buyer_id)
				setProxyDealer(res.data.data[0]?.buyer_dealer_id)
				setProxyTransport(res.data.data[0]?.transportation_charge)
			} else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}
		}).catch(function (error) {
			if (error.response) {
				setErrors(error.response.data.error)
				setErrorFlag(true)
			}
		});
	}

	const redirectpage = (pathid, seller_data) => {
		dispatch(UrCarAction.sellerid(seller_data))
		history.push({ pathname: "/editdetails", state: { backURL, id: pathid } });
	}

	function copytoclipboard(e) {
		document.execCommand('copy');
		e.target.focus();
		setCopySuccess('Copied!');
	}

	function img1Click(img) { setLrgImg(img.target.src); setIsVideoFlag(false) }
	function img2Click(img) { setLrgImg(img.target.src); setIsVideoFlag(false) }
	function img3Click(img) { setLrgImg(img.target.src); setIsVideoFlag(false) }
	function img4Click(img) { setLrgImg(img.target.src); setIsVideoFlag(false) }

	function video1Click(video) { setLrgVideo(video); setIsVideoFlag(true) }
	function video2Click(video) { setLrgVideo(video); setIsVideoFlag(true) }
	function video3Click(video) { setLrgVideo(video); setIsVideoFlag(true) }
	function video4Click(video) { setLrgVideo(video); setIsVideoFlag(true) }

	const handleMediaClick = (item) => {
		if (item.format === "image") {
			setLrgImg(item.image);
			setIsVideoFlag(false);
		} else {
			setLrgVideo(item.image);
			setIsVideoFlag(true);
		}
	};

	// useEffect(() => {
	// 	let intervalId = setInterval(() => {
	// 		CarDetailList();
	// 		ProxyBid();
	// 	}, 30000)
	// 	return () => clearInterval(intervalId)
	// }, [counterBitUpdated, id])

	const handleCounter = () => {
		setLoading(true)
		CarDetailList();
	}

	// useEffect(() => {
	// 	CarDetailList();
	// 	ProxyBid();
	// }, [counterBitUpdated, id])
	useEffect(() => {
		CarDetailList();
		ProxyBid();
	}, [id])

	// const handleCounter = () => {
	// 	setLoading(true)
	// 	requestCarDetailsViaWebSocket();
	// }

	const config = {
		background: "#f5f5f5",
		displayValue: false,
		marginTop: "20px",
		marginBottom: "20px",
		fontOptions: "italic",
		width: 2,
		heigth: 5
	};

	const privileges = (data) => {
		let request = {
			seller_dealer_id: data == undefined || data === null ? sellerData.seller_dealer_id : data.seller_dealer_id,
			seller_id: sellerData.seller_id,
			seller_token: sellerData.seller_token
		}
		API.post("sellerPrivileges/condition", request)
			.then((response) => {
				if (response.data.success === true) {
					setPrivilegeDetails(response.data.data[0])
				} else {
					setErrors(response.data.error)
					setErrorFlag(true)
				}
			}).catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});
	}

	const getAddSellerPrivileges = () => {
		togglePopup()
		setPopupMsg("Seller doesn't have Counter Bid Privilege");
		setPopupActionType("close");
		setPopupActionValue("ok");
	}

	const handleBackButton = () => {
		history.push({ pathname: back });
		ls.set("backredirection", backUrl.slice(0, -1))
	}

	async function logedBuyerFees() {
		let request = {
			type: "Seller",
			seller_id: successData.seller_id,
			seller_token: successData.seller_token,
		};
		const statePromise = API.post('fees/condition', request);
		statePromise.then(res => {
			if (res.data.success === true) {
				setFeeDetails(res.data.data);
			} else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}
		}).catch(function (error) {
			if (error.response) {
				setErrors(error.response.data.error)
				setErrorFlag(true)
			}
		});
	}

	const [showPopover, setShowPopover] = useState(false);
	const [carPrice, setCarPrice] = useState("")
	const [feeDetails, setFeeDetails] = useState("");

	const ref = useRef(null);

	useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);
		return () => { document.removeEventListener("mousedown", handleClickOutside); };
	}, []);

	const handleClickOutside = (event) => {
		if (ref.current && !ref.current.contains(event.target)) {
			setShowPopover(false);
		}
	};

	const handleBackButtonClick = (index, item) => {
		setShowPopover(!showPopover);
		setCarPrice(item);
	}

	const getFeeDetails = (maxPrice) => {
		return feeDetails.length > 0 ? feeDetails
			.filter((data) => {
				const range = data.from_price
				const rangeOne = data.to_price
				if (rangeOne !== "up") {
					return Number(range) <= Number(maxPrice) && Number(maxPrice) <= Number(rangeOne)
				} else {
					return Number(range) <= Number(maxPrice)
				}
			})[0]?.fee || 0
			: 0
	}

	function TotalSellerCharges(data) {
		let total = 0;
		if (Array.isArray(data)) {
			data.forEach(obj => {
				total += obj.seller_special_fee_amount !== null ? obj.seller_special_fee_amount : obj.defaultfeeamount;
			});
		}
		return total;
	}

	const totalPrice = Number(carPrice.high_bid || 0) -
		(Number(getFeeDetails(carPrice?.high_bid || 0)) +
			Number(TotalSellerCharges(carPrice?.sellerfeechargeslist)) +
			Number(carPrice?.bos_car_charges || 0));

	const TotalPriceForHighBid = (item) => {
		return Number(item.high_bid || 0) -
			(Number(getFeeDetails(item?.high_bid || 0)) +
				Number(TotalSellerCharges(item?.sellerfeechargeslist)) +
				Number(item?.bos_car_charges || 0));
	}

	const popover = (
		<Popover id="popover-basic" className="custom-popover">
			<Popover.Header as="h3" className="bg-danger text-white" >Vehicle Price</Popover.Header>
			<Popover.Body>
				<div className="Vehicle-Pricelist">
					<p>Price - <span>$ {carPrice.high_bid || 0}</span></p>
					<p>Sell Fee - <span>$ {getFeeDetails(carPrice.high_bid || 0)}</span></p>
					<p>Other Charges - <span>$ {TotalSellerCharges(carPrice.sellerfeechargeslist)}</span></p>
					<p>Miscellaneous Charges - <span>$ {carPrice.bos_car_charges || 0}</span></p>
					<p>Total Price - <span>$ {totalPrice}</span></p>
				</div>
			</Popover.Body>
		</Popover>
	);

	// ── Reusable thumb block (UPDATED WITH WORKING MAGNIFIER) ──────────────────────────────────────────
	const ThumbItem = ({ item, videoClick, originalIndex }) => (
		<div className="thumbnail-image">
			<div
				className="thumbImg"
				style={{ position: "relative", cursor: "pointer" }}
				onClick={() => {
					if (item?.format === "video") {
						setLrgVideo(item?.image);
						setIsVideoFlag(true);
					} else {
						setLrgImg(item?.image);
						setIsVideoFlag(false);
					}
				}}
			>
				{item?.format === "video" ? (
					<video autoBuffer controls width="100%" height="100%">
						<source id="mp4" className="card-img-top" src={item?.image} type="video/mp4" />
					</video>
				) : (
					<img
						src={item?.image}
						alt=""
						width="100%"
						height="100%"
						style={{ cursor: 'pointer' }}
					/>
				)}
			</div>
		</div>
	);

	const requestCarDetailsViaWebSocket = useCallback(() => {
		if (!id || !sellerData?.seller_id || !sellerData?.seller_token) return;

		const baseRequest = {
			car_id: id,
			seller_dealer_id: sellerDealerId,
			seller_id: sellerData.seller_id,
			seller_token: sellerData.seller_token,
		};

		send({ UpdatedData: baseRequest, model: "carDetails" });

		send({
			UpdatedData: {
				car_id: id,
				seller_id: sellerData.seller_id,
				seller_token: sellerData.seller_token,
			},
			model: "proxybidDetails"
		});

		send({
			UpdatedData: {
				seller_dealer_id: sellerDealerId,
				seller_id: sellerData.seller_id,
				seller_token: sellerData.seller_token,
			},
			model: "sellerPrivileges"
		});

		send({
			UpdatedData: {
				type: "Seller",
				seller_id: successData.seller_id,
				seller_token: successData.seller_token,
			},
			model: "fees"
		});
	}, [id, sellerDealerId, sellerData, successData, send]);

	useEffect(() => {
		if (sellerData?.seller_dealer_id && sellerData?.seller_token) {
			const timer = setTimeout(() => {
				requestCarDetailsViaWebSocket();
			}, 2000);
			return () => clearTimeout(timer);
		}
	}, [sellerData, requestCarDetailsViaWebSocket]);

	// carDetails pushed over the socket
	useEffect(() => {
		if (!carDetailsData?.data?.length) return;
		const res = { data: carDetailsData.data, data1: carDetailsData.data1 };

		// guard: only apply if it's for the car we're viewing
		if (String(res.data[0]?.car_id) !== String(id)) return;

		let merged = [];
		for (let i = 0; i < res.data.length; i++) {
			merged.push({
				...res.data[i], ...(res.data1?.find((item) => item.car_id === res.data[i].car_id))
			})
		}
		merged.sort((a, b) => a.car_image_type_id - b.car_image_type_id);
		setCarDetail(merged)
		setLrgImg(res.data[0]?.image);
		setLrgVideo(res.data[0]?.image);
		setLoading(false);
		setCarId(res.data[0]?.car_id)
		setBuyerDealerId(res.data[0]?.buyer_dealer_id)
		setSellerDealersId(res.data[0]?.seller_dealer_id)
		setHighBid(res.data[0]?.high_bid)
		setSellitNow(res.data[0]?.max_price)
		setBuyDealerId(res.data[0]?.high_buyer_dealer_id)
		setBuyerId(res.data[0]?.high_buyer_id)
		setTime(res.data[0]?.time)
		setCountBid(res.data[0]?.car_max_price)
		setNewBid(res.data[0]?.counter_bid)
		setTransportationCharge(res.data[0]?.transportation_charge)
		setIsVideoFlag(false)
	}, [carDetailsData]);

	// proxy bid pushed over the socket
	useEffect(() => {
		if (!proxyBidData?.length) return;
		setProxyBidList(proxyBidData);
		setProxyBid(proxyBidData[0]?.proxy_bid)
		setProxyBidDisplay(proxyBidData[0]?.display)
		setProxyBuyer(proxyBidData[0]?.buyer_id)
		setProxyDealer(proxyBidData[0]?.buyer_dealer_id)
		setProxyTransport(proxyBidData[0]?.transportation_charge)
	}, [proxyBidData]);

	// seller privileges pushed over the socket
	useEffect(() => {
		if (!sellerPrivilegesData?.length) return;
		setPrivilegeDetails(sellerPrivilegesData[0]);
	}, [sellerPrivilegesData]);

	// fee schedule pushed over the socket
	useEffect(() => {
		if (!feeDetailsData?.length) return;
		setFeeDetails(feeDetailsData);
	}, [feeDetailsData]);


	return (
		<main id="main" class="inner-page">
			{loading ? <Loading /> :
				<div id="products-details" class="products-details">
					{errorFlag === true ? <PageNotFound error={errors} /> :
						<div class="container-fluid inner-page-space">
							<div class="back-btn">
								<a class="back-btn-primary" onClick={() => handleBackButton()}><i class="bx bx-chevron-left"></i> Back</a>
							</div>
							<div class="row">
								{carDetail.length > 0 &&
									<div class="col-lg-6">
										<div class="vehicle-detail-banner banner-content clearfix">
											<div class="banner-slider">
												<div class="slider slider-for">
													<div class="slider-banner-image">
														<div
															style={{ position: "relative", cursor: "crosshair", display: "inline-block", width: "100%" }}
															onMouseMove={(e) => handleMouseMove(e, "large")}
															onMouseLeave={handleMouseLeave}
															onClick={() => handleImageClick(lrgImg, 0)}
														>
															{isVideoFlag === false
																? <img
																	src={lrgImg}
																	alt="no image"
																	width="390px"
																	height="470px"
																	style={{ display: 'block', width: '100%', height: 'auto', cursor: 'crosshair' }}
																/>
																: <video key={lrgVideo} autoBuffer controls width="390px" height="470px" style={{ width: '100%', height: 'auto' }}>
																	<source className="card-img-top" src={lrgVideo} type="video/mp4" />
																</video>
															}
															{cardMagnifier.show && cardMagnifier.activeId === "large" && (
																<div
																	className="magnifier-image"
																	style={{
																		left: `${cardMagnifier.x}px`,
																		top: `${cardMagnifier.y}px`,
																		backgroundImage: `url(${lrgImg})`,
																		backgroundPosition: `${cardMagnifier.imgX}% ${cardMagnifier.imgY}%`,
																	}}
																/>
															)}
														</div>
													</div>
												</div>

												<div className="slider slider-nav thumb-image">
													{carDetail.length > 4 && (
														<button className="arrow up" onClick={scrollUp}>▲</button>
													)}
													<div className="thumb-scroll-container" ref={sliderRef}>
														{carDetail.slice(1).map((item, index) => (
															<ThumbItem
																key={item.car_images_id || index}
																item={item}
																originalIndex={index + 1}
															/>
														))}
													</div>
													{carDetail.length > 4 && (
														<button className="arrow down" onClick={scrollDown}>▼</button>
													)}
												</div>
											</div>
										</div>
									</div>}

								{carDetail.length > 0 &&
									<div class="col-lg-6">
										<div class="product-dtl">
											<div class="cars-detail-inside">
												<div class="cars-detail-views">
													<p class="car-btns"><span className="greytext">Inventory # : </span> {carDetail[0].car_id}</p>
												</div>
											</div>
											<div class="product-info">
												<div class="product-name">
													<p>{carDetail[0].year} {carDetail[0].make} {carDetail[0].model}</p>
												</div>
												<div class="km-petrol">
													<p class="details"><img src={speedometer} alt="" /><span>{carDetail[0].mileage} {carDetail[0]?.mileage_type}</span></p>&nbsp;&nbsp;&nbsp;&nbsp;
													{carDetail[0].fuel_type == "null" || carDetail[0].fuel_type == "" || carDetail[0].fuel_type == null || carDetail[0].fuel_type == undefined || carDetail[0].fuel_type == "undefined" ? "" :
														<p class="details"><img src={gasolinePump} alt="" /><span>{carDetail[0].fuel_type}</span></p>}
													<a class="labeltype"><span>{carDetail[0].label_type === "Sealed Bid Sales" ? carDetail[0].label_type.substr(0, 10) : carDetail[0].label_type}</span></a>
												</div>
												<p class="odometer"><span className="label">Is Odometer working</span> : {carDetail[0].odometer}</p>
												{carDetail[0].days === 1 || carDetail[0].days == null || carDetail[0].days == "" ? <p class="remaindays">{carDetail[0].days} day still to go</p> :
													<p class="remaindays">{carDetail[0].days} days still to go</p>}
												{carDetail[0].announcement == "null" || carDetail[0].announcement == null || carDetail[0].announcement == "undefined" || carDetail[0].announcement == undefined ?
													<p><span className="label">Announcement : </span>{""}</p> :
													<p><span className="label">Announcement :  {carDetail[0].announcement}</span></p>}
												{carDetail[0].dealer_message == "" || carDetail[0].dealer_message == "undefined" || carDetail[0].dealer_message == null || carDetail[0].dealer_message == "null" ? <p><span class="dealertaglines">Message From The Dealer : </span>No Message</p> :
													<p><span class="dealertaglines">Message From The Dealer : {carDetail[0].dealer_message}</span></p>}
											</div>
											<div class="row vinqr">
												<div class="col-md-12 carpoints">
													<div className="label">Vin # : </div>
													<div class="carpoint">
														<img src={car} alt="" />
														<span>{carDetail[0].vin_no}</span>
														<CopyToClipboard text={carDetail[0].vin_no} onCopy={() => setCopied(true)}>
															<span title="Copy" onClick={copytoclipboard} className="copyImg"><i class="icofont-copy"></i></span>
														</CopyToClipboard>
														<img src={barcode} alt="" onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)} />
													</div>
												</div>
												{isShown && (
													<div>
														<Barcode value={carDetail[0].vin_no} {...config} />
													</div>
												)}
											</div>

											<div class="title-status">
												<p className="title-label">Title status :<span className='tit-sold'></span>
													<div className={`${carDetail[0]?.title === "Title" ? "title-cart" : carDetail[0]?.title === "Title Attached" ? "titleattached-cart" : carDetail[0]?.title === "Bill of sale only" ? "billofsale-cart" : ""}`}>{carDetail[0]?.title}</div>
												</p>
											</div>

											<div class="cars-detail-ins">
												{carDetail[0].sales_type_id == 1 ?
													<a class={sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "car-btns redBtn sealed_bid statuscolor" : "car-btns redBtn sealed_bid"} onClick={() => { togglePopupCarHistory() }}>Sealed Bid</a>
													:
													<>
														{carDetail[0].min_price == "" || carDetail[0].min_price == undefined || carDetail[0].min_price == null || carDetail[0].min_price == 0 ? "" :
															<a class="car-btns">Minimum Bid: <span class="green"> $ {carDetail[0].min_price}</span></a>
														}
														{carDetail[0].high_bid == "" || carDetail[0].high_bid == undefined || carDetail[0].high_bid == null ? "" : <>
															<a class="car-btns">High Bid : <span class="green"> $ {TotalPriceForHighBid(carDetail[0])}</span>
																<OverlayTrigger
																	trigger="click"
																	placement="top"
																	show={showPopover[carDetail[0].car_id]}
																	overlay={popover}
																	rootClose={true}
																	rootCloseEvent="click"
																	onHide={() => setShowPopover(false)}
																>
																	<Button onClick={() => handleBackButtonClick(carDetail[0].car_id, carDetail[0])} className="ms-2 float-end" variant="primary"><FontAwesomeIcon icon={faInfo} /></Button>
																</OverlayTrigger>
															</a>
														</>}
														{carDetail[0].max_price == "" || carDetail[0].max_price == undefined || carDetail[0].max_price == null || carDetail[0].max_price == 0 ? "" :
															<a class="car-btns">Sell it Now : <span class="red"> $ {carDetail[0].max_price}</span></a>
														}
													</>}
											</div>

											<div class="proxybid-sec">
												{proxyBidList.length > 0 ? proxyBidList.map((item) =>
													<>
														{item.display == "yes" ? <>
															{item.proxy_bid == "" || item.proxy_bid == undefined || item.proxy_bid == null ? "" :
																<a class="car-btns">Proxy Bid From Buyer : <span class="red"> $ {item.proxy_bid} </span></a>
															}
														</> : ""}
													</>
												) : ""}
											</div>

											<div className='autocheck-edit'>
												<div class="autocheck">
													<img src={carcheck} alt="" />
												</div>
												{(carDetail[0].time == 0 || carDetail[0].time === null) ?
													<a class={sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "cars-buy-btns-primary greyBtn statuscolor" : "cars-buy-btns-primary greyBtn"} onClick={() => !(sellerStandingStatus === 6 || sellerStandingStatus === 7) && redirectpage(carDetail[0].car_id, carDetail[0])}>Edit Details</a>
													: ""}
											</div>

											<div class="counterBid-sec">
												{carDetail[0].sales_type_id == 1 ?
													<>
														{carDetail[0].high_bid == "" || carDetail[0].high_bid == undefined || carDetail[0].high_bid == null ? "" :
															<div className="counterBid">
																{carDetail[0].time == 0 || carDetail[0].time === null
																	? <a class={sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "car-btns redBtn statuscolor" : "car-btns redBtn"} onClick={() => !(sellerStandingStatus === 6 || sellerStandingStatus === 7) && (privilegeDetails?.counter_bid == 1 ? togglePopupSealedCounterBid(carDetail[0]) : getAddSellerPrivileges())}>Counter Bid</a>
																	: <a class={sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "car-btns redBtn statuscolor" : "car-btns redBtn"} onClick={() => !(sellerStandingStatus === 6 || sellerStandingStatus === 7) && (privilegeDetails?.counter_bid == 1 ? togglePopupSealedCounterBid(carDetail[0]) : getAddSellerPrivileges())}>Update Counter Bid</a>}
															</div>}
													</>
													:
													<>
														{carDetail[0].high_bid == "" || carDetail[0].high_bid == undefined || carDetail[0].high_bid == null ? "" :
															<div className="counterBid">
																{carDetail[0].time == 0 || carDetail[0].time === null
																	? <a class={sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "car-btns redBtn statuscolor" : "car-btns redBtn"} onClick={() => !(sellerStandingStatus === 6 || sellerStandingStatus === 7) && (privilegeDetails?.counter_bid == 1 ? togglePopupCounter() : getAddSellerPrivileges())}>Counter Bid</a>
																	: <a class={sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "car-btns redBtn statuscolor" : "car-btns redBtn"} onClick={() => !(sellerStandingStatus === 6 || sellerStandingStatus === 7) && (privilegeDetails?.counter_bid == 1 ? togglePopupCounter() : getAddSellerPrivileges())}>Update Counter Bid</a>}
															</div>
														}
													</>
												}
											</div>

											<div class="custom-button-accept">
												{(carDetail[0].time == 0 || carDetail[0].time === null) ?
													<div class="cars-buy">
														{carDetail[0].high_bid == "" || carDetail[0].high_bid == undefined || carDetail[0].high_bid == null ? "" :
															<>
																{carDetail[0].sales_type_id == 1 ? "" :
																	<a class={sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "cars-buy-btns greenBtn statuscolor" : "cars-buy-btns greenBtn"} onClick={() => !(sellerStandingStatus === 6 || sellerStandingStatus === 7) && togglePopupAccept()}>Accept</a>}
															</>}
													</div> :
													<p class="car-btns smallBtn waiting">Waiting for counter Bid</p>}
												{proxyBid && proxyBidDisplay == "yes" ? <>
													<a class="cars-buy-btns greenBtn butnpad-apb" onClick={togglePopupProxyAccept}>Accept Proxy Bid</a></> : ""}
												<div class={carDetail[0].time !== null && carDetail[0].time < 21 ? "countownBlock" : ""}>
													<CounterBidTimer Seconds={carDetail[0].Seconds} onData={handleData} />
												</div>
											</div>

											<div class={proxyBidList.length > 0 ? "" : ""}>
												{carDetail[0].sales_type_id == 1 ? "" :
													<div class="cars-detail-ins">
														<a class={sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "cars-buy-btns redBtn butnpad statuscolor" : "cars-buy-btns redBtn butnpad"} onClick={() => !(sellerStandingStatus === 6 || sellerStandingStatus === 7) && togglePopupBidList()}>Bid Details</a>
														{proxyBidList.length > 0 ?
															<a class={sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "cars-buy-btns redBtn butnpad statuscolor" : "cars-buy-btns redBtn butnpad"} onClick={() => !(sellerStandingStatus === 6 || sellerStandingStatus === 7) && togglePopupProxyList()}>Proxy Bid Details</a>
															: ""}
														<a class={sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "cars-buy-btns redBtn statuscolor " : "cars-buy-btns redBtn"} onClick={() => !(sellerStandingStatus === 6 || sellerStandingStatus === 7) && toggleApprove()}>Inactive</a>
													</div>
												}
											</div>

											{carDetail[0].time == 0 || carDetail[0].time === null ? "" :
												<p className="">* Previous Sell it Now : {countBid}</p>}
										</div>
									</div>}
							</div>
						</div>}
					{isOpenPrivileges &&
						<CommonPopup
							handleClose={togglePopup}
							popupTitle={popupTitle}
							popupMsg={popupMsg}
							popupType={popupType}
							popupActionType={popupActionType}
							popupActionValue={popupActionValue}
							popupActionPath={popupActionPath}
						/>
					}
				</div>}

			<section id="playstoreBlock" class="playstoreBlock">
				<div class="container">
					<div class="row content">
						<div class="col-lg-12">
							<img src={appstore} />
							<img src={googleplay} />
						</div>
					</div>
				</div>
			</section>

			{isOpenCounter && <Popup isClose={false} content={<><UrCarCounterBid toggle={togglePopupCounter} buyerDealerId={buyerDealerId} highBid={highBid} sellitNow={sellitNow} counterBitUpdateFlag={counterBitUpdateHandler} carId={carId} time={time} countBid={countBid} newBid={newBid} handleCounter={handleCounter} /></>} handleClose={togglePopupCounter} />}
			{isOpenBidList && <Popup isClose={false} content={<><UrCarBidList toggle={togglePopupBidList} carId={carId} handleCounter={handleCounter} /></>} handleClose={togglePopupBidList} />}
			{isOpenProxyList && <Popup isClose={false} content={<><UrCarProxyList toggle={togglePopupProxyList} carId={carId} handleCounter={handleCounter} /></>} handleClose={togglePopupProxyList} />}
			{isOpenAccept && <Popup isClose={false} content={<><Accept toggle={togglePopupAccept} carId={carId} buyDealerId={buyDealerId} buyerId={buyerId} buyerDealerId={buyerDealerId} highBid={highBid} sellitNow={sellitNow} transportationCharge={transportationCharge} counterBitUpdateFlag={counterBitUpdateHandler} time={time} countBid={countBid} newBid={newBid} handleCounter={handleCounter} /></>} handleClose={togglePopupAccept} />}
			{isOpenProxyAccept && <Popup isClose={false} content={<><ProxyAccept toggle={togglePopupProxyAccept} carId={carId} proxyBid={proxyBid} proxyBuyer={proxyBuyer} proxyDealer={proxyDealer} proxyTransport={proxyTransport} counterBitUpdateFlag={counterBitUpdateHandler} time={time} countBid={countBid} newBid={newBid} handleCounter={handleCounter} /></>} handleClose={togglePopupAccept} />}
			{isOpenCarHistory && <Popup isClose={false} content={<><SealedBid toggle={togglePopupCarHistory} highBid={highBid} carId={carId} buyDealerId={buyDealerId} buyerId={buyerId} sellerDealersId={sellerDealersId} sellitNow={sellitNow} isOpenCarHistory={isOpenCarHistory} transportationCharge={transportationCharge} /></>} handleClose={togglePopupCarHistory} />}
			{isOpenSealedCounterBid && <Popup isClose={false} content={<><SealedCounterBid toggle={togglePopupSealedCounterBid} buyerDealerId={buyerDealerId} highBid={highBid} sellitNow={sellitNow} counterBitUpdateFlag={counterBitUpdateHandler} carId={carId} time={time} countBid={countBid} newBid={newBid} handleCounter={handleCounter} /></>} handleClose={togglePopupSealedCounterBid} />}
			{deleteCar && <Popup isClose={false} content={<><Delete toggle={toggleApproveDelete} carId={carId} flag="Inactive" /></>} handleClose={toggleApproveDelete} />}

			{isPopupOpen && (
				<PopupMagnifier
					images={popupImages}
					currentIndex={currentImageIndex}
					onClose={() => setIsPopupOpen(false)}
					onNext={handleNextImage}
					onPrev={handlePrevImage}
				/>
			)}
		</main>
	)
}

export default CarDetails;